import type { Workspace } from '@carboncopyco/types';
import type { ReactNode } from 'react';
import { WorkspacesPageArchivedTileActions } from './WorkspacesPageArchivedTileActions';
import { useWorkspacesPage } from './WorkspacesPageContext';
import { WorkspacesPageTileActions } from './WorkspacesPageTileActions';

export const WorkspacesPageTableRowWrapper = ({
  item,
  children,
}: {
  item: Workspace;
  children: ReactNode;
}) => {
  const { navigateToWorkspace } = useWorkspacesPage();

  return (
    <div
      onClick={
        item.isMember && !item.isDeleted
          ? () => navigateToWorkspace(item.id)
          : null
      }
      className="flex justify-between hover:bg-ds-natural-50 py-2 rounded-md mb-1 cursor-pointer"
    >
      <div>{children}</div>
      {item.isMember && (
        <div className="pr-6">
          {!item.isDeleted ? (
            <WorkspacesPageTileActions workspace={item} />
          ) : (
            <WorkspacesPageArchivedTileActions workspace={item} />
          )}
        </div>
      )}
    </div>
  );
};
